import { defineComponent as _defineComponent } from 'vue'
import ProductTourStep from '@/components/core/productTour/ProductTourStep.vue'
import { TransportationType, transportationTypes } from '@/types/transportation'
import { getDefaultEmojiForTransportationType } from '@/utils/transportation'

export interface TransportationSelectorProps {
  /** The selected transportation type */
  value: TransportationType
  /** Disables type switching (e.g. when editing an existing transportation) */
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationSelector',
  props: {
    value: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: TransportationType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** The selected transportation type */
  value: TransportationType
  /** Disables type switching (e.g. when editing an existing transportation) */
  disabled?: boolean
};





function selectTransportation(type: TransportationType) {
  if (props.disabled) {
    return
  }
  emit('input', type)
}

return { __sfc: true,props, emit, selectTransportation, ProductTourStep, transportationTypes, getDefaultEmojiForTransportationType }
}

})